import React from "react";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";

const ConcernSelectButton = ({ count = 0, onClick }) => {
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={onClick}
      className="w-full"
      startIcon={
        count > 0 ? (
          <Badge badgeContent={count} color="primary">
            <HealthAndSafetyIcon />
          </Badge>
        ) : (
          <HealthAndSafetyIcon />
        )
      }
    >
      {count > 0 ? `${count} Concerns Selected` : "Select Concerns"}
    </Button>
  );
};

export default ConcernSelectButton;
